import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';


class Notifications extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TransitionGroup>
        {_.map(this.props.notifications, (notification, idx) => {
          const class_names = classNames({
            cNotification: true,
            error: notification.is_error
          });
          return (
            <CSSTransition
              classNames='cNotification'
              key={idx}
              timeout={{ enter: 200, exit: 300 }}
            >
              <div className={class_names}>
                {!notification.is_error
                  ? <i className='btl bt-check-circle' />
                  : null}
                {' '} {notification.value}
              </div>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notifications: state.notifications.notifications
});

export default connect(mapStateToProps)(Notifications);
